<template>
  <div :class="[
      'flex flex-col right-[13rem] w-[90%] md:w-[400px] static md:absolute -translate-y-[1rem] bg-GRIS_CLARO_BUSCAR_NEUMATICO rounded-md px-3 pt-5 py-2 gap-4 md:mt-0 z-30',
      containerClasses]"
  >
    <p class="text-ROJO_LEON flex justify-center items-center font-bold">
      <img class="h-2 mx-1 md:items-start" :src="'/img/shared/point-arrow-iconv2.svg'" alt="point-arrow-icon" />
      Busca tus neumáticos por:
    </p>

    <div class="contenedor_botones flex justify-evenly [&>label]:min-w-[150px] flex-wrap items-center mt-0">
      <div v-for="search in searchTypes" :key="search.id">
        <input
          type="radio" :id="search.id" class="hidden peer" :value="search.value"
          :checked="modoFormulario === search.value" @click="setmodoFormulario(search.value)"
        />
        <label :for="search.id" :class="['rounded-lg text-center block px-6 md:px-8 py-2 transition cursor-pointer',
          modoFormulario === search.value ? 'bg-ROJO_LEON text-white' : 'bg-GRIS_BUTTONS text-black']"
        >
          <div class="flex flex-row flex-wrap items-center align-middle">
            <img :src="search.iconSrc" alt="" :class="['mr-2', search.value == 1 ? 'h-4 md:h-4' : 'h-5 md:h-5']"
              :style="modoFormulario == search.value
                ? 'filter: grayscale(100%) brightness(0) invert(100%)'
                : 'filter: grayscale(100%) brightness(0)'"
            />
            {{ search.label }}
          </div>
        </label>
      </div>
    </div>

    <!-- Por auto -->
    <div class="flex flex-col justify-center pt-2 h-full" v-show="modoFormulario == 1">
      <div>
        <FormularioAuto
          :selectedSearch="selectSeleccionado"
          :brands="brands"
          :years="years"
          :models="models"
          :versions="versions"
          :loadingBrands="loadingBrands"
          :loadingYears="loadingYears"
          :loadingModels="loadingModels"
          :loadingVersions="loadingVersions"
          :selectedBrand="selectedBrand"
          :selectedYear="selectedYear"
          :selectedModel="selectedModel"
          @setSelectMasInputBrand="setSelectMasInputBrand"
          @setSelectMasInputYear="setSelectMasInputYear"
          @setSelectMasInputModel="setSelectMasInputModel"
          @setSelectMasInputVersion="setSelectMasInputVersion"
          @onChangeBrand="onChangeBrand"
          @onChangeYear="onChangeYear"
          @onChangeModel="onChangeModel"
          @onChangeVersion="onChangeVersion"
        />

        <div class="flex flex-col mb-5 items-center pt-1">
          <InputSearch @cambioUbicacion="cambioUbicacion" :searchType="1" :isEnabled="!!selectedVersion" />
          <button
            class="mt-4 boton_buscar flex items-center w-[50%] h-10 gap-1 justify-center rounded-md text-white text-sm disabled:opacity-60 bg-VERDE_TOP_CALIDAD"
            :disabled="isDisabledCar || isDisabledCarButton || direccion_auto_vacia_o_difiere || isLoadingLocation"
            @click="busqueda_por_auto"
          >
            <p class="text-base md:text-base font-bold text-white">Buscar</p>
            <LoaderSvg strokeColor="white" sizeClass="w-4 h-4 ml-1" v-show="isDisabledCarButton" />
          </button>
        </div>
      </div>
    </div>

    <!-- Por medida -->
    <div v-show="modoFormulario == 2">
      <div class="mt-2">
        <FormularioMedida
          :containerClass="'flex-col md:flex-col'"
          :disableAutoScroll="true"
          :selectedSearch="selectSeleccionado"
          :widths="widths"
          :perfiles="perfiles"
          :rings="rings"
          :loadingWidths="loadingWidths"
          :loadingperfiles="loadingperfiles"
          :loadingRings="loadingRings"
          :selectedWidth="selectedWidth"
          :selectedTireProfile="selectedTireProfile"
          :selectedRing="selectedRing"
          @setSelectMasInputWidth="setSelectMasInputWidth"
          @setSelectMasInputTireProfile="setSelectMasInputTireProfile"
          @setSelectMasInputRing="setSelectMasInputRing"
          @onChangeWidth="onCambiarAncho"
          @onChangeTireProfile="onCambiarPerfil"
          @onChangeRing="onCambiarAro"
        />

        <div class="flex flex-col mb-5 items-center pt-1">
          <InputSearch @cambioUbicacion="cambioUbicacion" :searchType="2" :isEnabled="!!selectedRing" />
          <button
            class="mt-4 boton_buscar flex items-center w-[50%] h-10 gap-1 justify-center rounded-md text-white text-sm disabled:opacity-60 bg-VERDE_TOP_CALIDAD"
            :disabled="isDisabled || isDisabledMedidaButton || direccion_medida_vacia_o_difiere || isLoadingLocation"
            @click="busqueda_por_medida"
          >
            <p class="text-base md:text-base font-bold text-white">Buscar</p>
            <LoaderSvg v-if="isDisabledMedidaButton" strokeColor="white" sizeClass="w-4 h-4 ml-1" />
          </button>
        </div>
      </div>
    </div>
  </div>

  <ModalError firstButtonText="Aceptar" :show="showErrorModalApi" @closeModal="closeErrorModalApi" :message="messageErrorApi" />

  <ModalConfirm
    :firstButtonText="'Continuar'" @handleConfirm="manejar_continuar"
    :secondButtonText="'Cancelar'" @closeModal="manejar_cancelar"
    :message="message" :show="isModalVisible" :showActionMessage="false"
  />
</template>

<script setup>
import { PROFILE, RING, WIDTH } from "~/constants/constantes_varias";
import ModalConfirm from "~/components/Shopping/ModalConfirm.vue";
import ModalError from "~/components/Shopping/Summary/ModalError.vue";
import { useStore } from "vuex";
import LoaderSvg from "~/components/Ui/LoaderSvg.vue";
import FormularioMedida from "~/components/Formularios/FormularioMedida.vue";
import FormularioAuto from "~/components/Formularios/FormularioAuto.vue";

const store = useStore();
const {
  products,
  isLoadingLocation,
  local_cambio,
  localpivote,
  fullcercano,
  ubication,
  getLocalPivote,
  getUbicationConfirmed,
  getProducts,
  getFullcercano,
  getUbication,
  setUbicationConfirmed,
  setFullcercano,
  setLocalCambio,
  clearCart
} = useCartBridge();

const config = useRuntimeConfig();

const debug = {
  enabled: config.public.modo === 'DEV',
  log(...args) { if (this.enabled) console.log(...args); },
  error(...args) { if (this.enabled) console.error(...args); },
};

const isBrandsLoaded = ref(false);
const router = useRouter();
const isModalVisible = ref(false);

const { getDeviceUUID, getSearchUUID } = useGeneradorUUIDS();

const message = ref(
  "Si cambias tu ubicación, es posible que te derivemos a un local diferente, pudiendo producirse modificaciones en tu carro de compras, productos, stock o precios."
);
const modoFormulario = ref(2);

const containerClasses = computed(() =>
  modoFormulario.value === 1 ? 'md:-translate-y-[36rem]' : 'md:-translate-y-[34rem]'
);

const searchTypes = ref([
  { id: "measure", value: 2, iconSrc: "/img/shared/neumaticos-icon.webp", label: "Medida" },
  { id: "car", value: 1, iconSrc: "/img/SVG/tipos-de-vehiculos/Autov2.svg", label: "Auto" },
]);

const isDisabledMedidaButton = ref(false);
const isDisabledCarButton = ref(false);
const { trace } = useTraceLog('components->FormularioNeumaticos.vue');

const direccion_usuario = computed(() => ubication.value.address);
const direccion_auto_vacia_o_difiere = ref(ubication.value.address == "");
const direccion_medida_vacia_o_difiere = ref(ubication.value.address == "");
const { insertDashboardPersona, insertDashboardData, insertDashboardNeumaticos } = useDashboardNeu();
const { iniciarFormularioBusqueda } = useFormularioExitIntent();

const {
  selectSeleccionado,
  onCambiarAncho, onCambiarPerfil, onCambiarAro,
  widths, perfiles, rings,
  loadingRings, loadingperfiles, loadingWidths,
  getWidths,
  selectedWidth, selectedTireProfile, selectedRing,
  safeDestroy, curvarTexto, cambiarAnchoTextoCurvo, cambiarPerfilTextoCurvo, cambiarAroTextoCurvo,
  brands, models, years, versions,
  loadingBrands, loadingModels, loadingYears, loadingVersions,
  onChangeBrand, onChangeModel, onChangeYear, onChangeVersion,
  getMarcas,
  showErrorModalApi, messageErrorApi, closeErrorModalApi,
  isDisabled, isDisabledCar,
  selectedBrand, selectedModel, selectedYear, selectedVersion,
  storeMedidaYAvanzar, storeAutoYAvanzar,
  loadChargedData
} = UseTireMeasure();

const avanzar = async (tipo) => {
  const loadingBar = document.getElementById("loading-bar");
  if (loadingBar) {
    loadingBar.classList.add("transition-all", "duration-300", "ease-in-out");
    let progress = 0;
    const interval = setInterval(() => {
      progress += 25;
      loadingBar.style.width = `${progress}%`;
      if (progress >= 100) {
        clearInterval(interval);
        loadingBar.classList.remove("transition-all", "duration-300", "ease-in-out");
      }
    }, 200);
  }

  console.log("30-09 localpivote.value: ", localpivote.value);
  console.log("30-09 ubication.value: ", ubication.value);
  setFullcercano(localpivote.value);
  setUbicationConfirmed(ubication.value);

  try {
    if (tipo === 'medida') {
      await esperarAcotado(dc_insertdashboard());
      storeMedidaYAvanzar();
    } else {
      await storeAutoYAvanzar();
    }
  } catch (error) {
    console.error("Error en avanzar:", error);
    isDisabledMedidaButton.value = false;
    isDisabledCarButton.value = false;
  }
};

// El registro de la búsqueda (dashboard + sesión del formulario exit-intent) no tiene timeout en ningún tramo: se
// espera como máximo DASHBOARD_MAX_WAIT_MS antes de ir a la PLP y, si se agota, sigue en segundo plano (navegación SPA).
const DASHBOARD_MAX_WAIT_MS = 3000;
const esperarAcotado = promesa => Promise.race([
  promesa,
  new Promise(resolve => setTimeout(resolve, DASHBOARD_MAX_WAIT_MS)),
]);

const dc_insertdashboard = async () => {
  try {
    const uuid_busqueda = await getSearchUUID(true);
    const uuid_dispositivo = await getDeviceUUID();
    const localCercano = fullcercano.value;
    const dashboardData = {
      uuid: uuid_busqueda,
      uuid_persona: uuid_dispositivo,
      local_id: localCercano.local_id,
      local_id_compra: null,
      usuario_ubicacion: ubication.value.address,
      usuario_latitud: String(ubication.value.latitude),
      usuario_longitud: String(ubication.value.longitude),
      tipo_busqueda: "por_medida",
      vehiculo_marca: null,
      vehiculo_anno: null,
      vehiculo_modelo: null,
      vehiculo_version: null
    };
    const neumaticosData = [{
      uuid: uuid_busqueda,
      ubicacion: "delantero-trasero",
      ancho: selectedWidth.value,
      perfil: selectedTireProfile.value,
      aro: selectedRing.value
    }];

    // Sin await: la búsqueda del popup corre en paralelo, sin depender del registro antiguo (sus insert* relanzan
    // errores) ni retrasarlo. No lanza (devuelve false) y su copia en localStorage se guarda al instante.
    iniciarFormularioBusqueda({
      dashboardUuid: uuid_busqueda,
      personaUuid: uuid_dispositivo,
      latitud: dashboardData.usuario_latitud,
      longitud: dashboardData.usuario_longitud,
      local: localCercano.fantasia || localCercano.nombre || localCercano.comuna_nombre || localCercano.local_id,
      localId: localCercano.local_id,
      tipoBusqueda: dashboardData.tipo_busqueda,
      vehiculo: null,
      neumaticos: neumaticosData,
    });

    await Promise.all([
      insertDashboardPersona({ uuid: uuid_dispositivo }),
      insertDashboardData(dashboardData),
      insertDashboardNeumaticos(neumaticosData[0]),
    ]);
  } catch (error) {
    console.error('Error en dashboard:', error);
  }
};

const cambioUbicacion = (value, type) => {
  if (direccion_usuario.value != value || value == "") {
    if (type == 1) direccion_auto_vacia_o_difiere.value = true;
    else direccion_medida_vacia_o_difiere.value = true;
  } else {
    if (type == 1) direccion_auto_vacia_o_difiere.value = false;
    else direccion_medida_vacia_o_difiere.value = false;
  }
};

const setmodoFormulario = async (value) => {
  if (value == 1 && !isBrandsLoaded.value) {
    isBrandsLoaded.value = true;
    getMarcas();
  }

  modoFormulario.value = value;

  if (value == 2) {
    await nextTick();
    curvarTexto();
  } else {
    safeDestroy();
  }
};

const setSelectMasInputWidth = (value) => { selectSeleccionado.value = value; cambiarAnchoTextoCurvo(); };
const setSelectMasInputTireProfile = (value) => { selectSeleccionado.value = value; cambiarPerfilTextoCurvo(); };
const setSelectMasInputRing = (value) => { selectSeleccionado.value = value; cambiarAroTextoCurvo(); };
const setSelectMasInputBrand = (value) => { selectSeleccionado.value = value; };
const setSelectMasInputYear = (value) => { selectSeleccionado.value = value; };
const setSelectMasInputModel = (value) => { selectSeleccionado.value = value; };
const setSelectMasInputVersion = (value) => { selectSeleccionado.value = value; };

const manejar_cancelar = () => {
  isModalVisible.value = false;
  isDisabledMedidaButton.value = false;
};

const manejar_continuar = async () => {
  isModalVisible.value = false;
  setLocalCambio(false);
  clearCart();

  if (modoFormulario.value == 1) {
    isDisabledCarButton.value = true;
    await avanzar('auto');
  } else {
    isDisabledMedidaButton.value = true;
    await avanzar('medida');
  }
};

const busqueda_por_medida = async () => {
  isDisabledMedidaButton.value = true;
  if (local_cambio.value == false) {
    await avanzar('medida');
  } else {
    isModalVisible.value = true;
    isDisabledMedidaButton.value = false;
  }
};

const busqueda_por_auto = async () => {
  isDisabledCarButton.value = true;
  try {
    store.commit("plpModule/updateProducts", []);
    store.commit("plpModule/updateFilterProducts", []);

    if (local_cambio.value == false) {
      await avanzar('auto');
    } else {
      isModalVisible.value = true;
    }
  } catch (error) {
    console.error("Error en busqueda_por_auto:", error);
  } finally {
    isDisabledCarButton.value = false;
  }
};

onMounted(async () => {
  // loadChargedData ahora vive en el composable
  const tieneMarcasCargadas = loadChargedData();
  if (tieneMarcasCargadas) isBrandsLoaded.value = true;

  getProducts();
  getFullcercano();
  getLocalPivote();
  getUbication();
  getUbicationConfirmed();
  store.commit("plpModule/getVehicleData");
  isDisabledMedidaButton.value = false;
  isDisabledCarButton.value = false;

  if (store.state.plpModule.vehicleData?.length > 0 && store.state.plpModule.searchVehicleTimeStamp) {
    modoFormulario.value = 1;
  }

  await getWidths();

  if (modoFormulario.value == 2) {
    await nextTick();
    curvarTexto();
  }
});

onUnmounted(() => {
  safeDestroy();
});

watch(() => localpivote.value?.local_id, (newLocalId) => {
  if (newLocalId && fullcercano.value?.local_id && products.value.length > 0) {
    setLocalCambio(newLocalId !== fullcercano.value.local_id);
  }
});

watch(isLoadingLocation, (newVal) => {
  trace("Watch isLoadingLocation() newVal:", newVal);
  trace("Watch isLoadingLocation() ubication.value:", ubication.value);
});

watch(() => selectSeleccionado.value, (nuevo_valor) => {
  if (nuevo_valor == WIDTH) cambiarAnchoTextoCurvo();
  else if (nuevo_valor == PROFILE) cambiarPerfilTextoCurvo();
  else if (nuevo_valor == RING) cambiarAroTextoCurvo();
});

watch(modoFormulario, async (newValue, oldValue) => {
  if (newValue == 2) {
    await nextTick();
    curvarTexto();
  } else if (oldValue == 2 && newValue == 1) {
    safeDestroy();
  }
});
</script>

<style scoped>
.boton_buscar:disabled {
  background-color: rgb(209 209 209);
  color: black;
}
</style>